import { Node } from "reactflow";
import { atom } from "jotai";

export const sidebarOpenNodeIdAtom = atom<Node["id"]>("");

sidebarOpenNodeIdAtom.debugLabel = "sidebarOpenNodeIdAtom";
